import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import _ from 'lodash';
let AdminService = class AdminService {
    constructor(AdminApi) {
        this.AdminApi = AdminApi;
    }
    getManagerUserList(params) {
        return this.AdminApi.getManagerUserList(params);
    }
    postEditBatchRoles(params) {
        return this.AdminApi.postEditBatchRoles(params);
    }
    async getPatsnapAccountList(params) {
        const res = await this.AdminApi.getPatsnapAccountList(params);
        return res;
    }
    getHistoryList(params) {
        const res = this.AdminApi.getHistoryList(params);
        return res;
    }
    postAccountsPatsnap(emails, reseller = false) {
        return this.AdminApi.postAccountsPatsnap(emails, reseller);
    }
    postAccountReseller(params) {
        return this.AdminApi.postAccountReseller(params);
    }
    isAdminOrDevelopAdmin(item) {
        const isAdminOrDevelopAdmin = _.find(item.role_patsnap_pojos, f => {
            if (f.id === 'backoffice-developer_admin' || f.id === 'id_backoffice_admin') {
                return true;
            }
        });
        if (isAdminOrDevelopAdmin) {
            return true;
        }
    }
    /**
     * 超级管理员
     */
    isSuperAdmin(item) {
        const isSuperAdmin = _.find(item.role_patsnap_pojos, f => {
            if (f.id === 'backoffice-developer_admin') {
                return true;
            }
        });
        if (isSuperAdmin) {
            return true;
        }
    }
    async getAuditLog(params) {
        return await this.AdminApi.getAuditLog(params);
    }
    // #region 组织管理相关方法
    /**
     * 获取部门列表
     */
    getDepartmentList() {
        return this.AdminApi.getDepartmentList();
    }
    /**
     * 新增部门
     */
    async postDepartment(params) {
        return await this.AdminApi.postDepartment(params);
    }
    /**
     * 编辑部门
     */
    async putDepartment(params) {
        return await this.AdminApi.putDepartment(params);
    }
    /**
     * 删除部门
     */
    async deleteDepartment(id) {
        return await this.AdminApi.deleteDepartment(id);
    }
    /**
     * 获取员工列表
     */
    async getEmployeeList(departmentId, page, size) {
        return await this.AdminApi.getEmployeeList(departmentId, page, size);
    }
    /**
     * 新增员工
     */
    async postEmployee(params) {
        return await this.AdminApi.postEmployee(params);
    }
    /**
     * 编辑员工
     */
    async putEmployee(params) {
        return await this.AdminApi.putEmployee(params);
    }
    /**
     * 删除员工
     */
    async deleteEmployee(id) {
        return await this.AdminApi.deleteEmployee(id);
    }
    /**
     * 判断是否为管理员
     */
    isAdmin(chargerType) {
        return chargerType === '1';
    }
    /**
     * 判断是否为成员
     */
    isMember(chargerType) {
        return chargerType === '0';
    }
    // #endregion
    // #region CORS白名单管理相关方法
    /**
     * 获取所有环境的CORS白名单配置
     */
    async getCorsWhitelist() {
        const response = await this.AdminApi.getCorsWhitelist();
        console.log('CORS whitelist get response:', response);
        if (response.status && response.error_code === 0 && response.data?.whitelist) {
            return response.data.whitelist;
        }
        return [];
    }
    /**
     * 更新指定环境的CORS白名单配置
     */
    async updateCorsWhitelist(params) {
        const response = await this.AdminApi.updateCorsWhitelist(params);
        console.log('CORS whitelist update response:', response);
        // 检查status字段和error_code
        if (response.status && response.error_code === 0) {
            return true;
        }
        return false;
    }
};
AdminService = __decorate([
    injectable(),
    __param(0, inject(Symbols.AdminApi)),
    __metadata("design:paramtypes", [Object])
], AdminService);
export { AdminService };
